// extracted by mini-css-extract-plugin
export var arrow = "testimonial-box-module--arrow--2d66c";
export var btnBox = "testimonial-box-module--btnBox--94d18";
export var description = "testimonial-box-module--description--d6482";
export var heading = "testimonial-box-module--heading--9d6e8";
export var img = "testimonial-box-module--img--288f3";
export var imgBox = "testimonial-box-module--imgBox--625de";
export var rightArrow = "testimonial-box-module--rightArrow--98a99";
export var testimonialBox = "testimonial-box-module--testimonialBox--d5a21";
export var textBox = "testimonial-box-module--textBox--d58e5";